import styled from 'styled-components';
import { StyleVars, getColor } from 'core/utils';

export const Wrapper = styled.a`
	display: flex;
	align-items: center;
	cursor: pointer;
	scroll-behavior: smooth;

	svg {
		margin-right: 10px;
	}
`;

export const Text = styled.p`
	margin: 0;
	font-weight: 400;
	line-height: 40px;
	font-size: 16px;
	color: ${getColor("lavender")};
`;
